/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Suspended_ProjectInputs */

const es_co2_error_invitation_suspended_project = /** @type {(inputs: Error_Invitation_Suspended_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No puedes aceptar una invitación a un proyecto suspendido.`)
};

/**

* @param {Error_Invitation_Suspended_ProjectInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_invitation_suspended_project = /** @type {((inputs?: Error_Invitation_Suspended_ProjectInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Suspended_ProjectInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_invitation_suspended_project(inputs)
});